import React, { useEffect, useRef, useState } from "react";
import { directDeepLink } from "@src/common/deepLinks";
import { hitDeeplinkExecutedV2, hitDeeplinkPerformAction } from "@src/utils/hitDeeplink";
import { COMMON_DEEPLINK_ACTIONS } from "@src/utils/constants";

const MoneyBackClaimCard = ({ data }) => {


  function detectMobileOS() {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
  
    if (/android/i.test(userAgent)) {
        return "Android";
    } else if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
        return "iOS";
    } else {
        return "Other";
    }
  }

const openData = ()=>{
 if(detectMobileOS() == 'iOS'){
      hitDeeplinkExecutedV2(
              JSON.stringify({
                screen: COMMON_DEEPLINK_ACTIONS.UTIL_BROWSER,
                paramOne: 'https://api.whatsapp.com/send?phone=919560201114&text=I%20Want%20To%20Claim%20Refund%20On%20My%20Course',
              }),
              JSON.stringify({
                screen: COMMON_DEEPLINK_ACTIONS.UTIL_BROWSER,
                paramOne: 'https://api.whatsapp.com/send?phone=919560201114&text=I%20Want%20To%20Claim%20Refund%20On%20My%20Course',
              })
            );
    }else{
      const newDeepLink = {};
      newDeepLink.paramOne = "https://api.whatsapp.com/send?phone=919560201114&text=I%20Want%20To%20Claim%20Refund%20On%20My%20Course";
      directDeepLink({}, "UTIL_WEBVIEW", false)(newDeepLink);
    }
}

  return (
    <>
      <div className="MoneyBack">
        <div className="MoneyBackCard MoneyBackCardClaimNow">
          <img
            src="https://cdn-cp-assets-public.classplus.co/web/courseWebview/content/moneyBackGuaranteeImg.png"
            alt="img"
            width={32}
          />
          <div className="cardHeader">
            <h4>Money Back Guarantee</h4>
            <p>
            Initiate your refund request now
            </p>
            <button onClick={openData}>Claim Now</button>
          </div>
        </div>
      </div>
    </>
  );
};
const MemoizedAboutCourse = React.memo(MoneyBackClaimCard);
export default MemoizedAboutCourse;

